// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"170":"css/app","184":"famaliving/css/famaliving","622":"solutions/solutions","701":"fama/css/fama","822":"css/cookies","841":"css/cms","942":"fama/css/layouts/404"}[chunkId] + ".css";
};